//import * as FileSystem from 'expo-file-system';

import * as FileSystem from 'fs';
import * as FileSystemPromises from 'fs/promises';

export const deleteEpaperFolder = async (date: string, edition: string) => {

  console.warn('deleteEpaperFolder - Directory not found:', 'No local epaper found.');
  return;


  /*
  const epaperDir = FileSystem.documentDirectory + `epaper/${date}/${edition}`;
  console.log(`Attempting to delete directory: ${epaperDir}`);
  
  try {
    const dirInfo = await FileSystem.getInfoAsync(epaperDir);
    
    if (!dirInfo.exists) {
      console.log('Directory not found:', 'No local epaper found.');
      return;
    }

    // Retrieve and log directory contents before deletion
    //const directoryContents = await FileSystem.readDirectoryAsync(epaperDir);
    //console.log('Files and folders found for deletion:', directoryContents);
    
    await FileSystem.deleteAsync(epaperDir, { idempotent: true });
    //console.log('Success:', 'Epaper folder deleted.');
  } catch (error) {
    console.error('Error deleting directory:', error);
    console.log('Error:', 'There was an error deleting the /epaper/ directory.');
  }
  */
};

export const deleteImageFolder = async (date: string) => {


  console.warn('deleteImageFolder - Directory not found:', 'No local epaper found.');
  return;



  /*
  const epaperDir = FileSystem.documentDirectory + `epaper/${date}/`;
  console.log(`Attempting to delete directory: ${epaperDir}`);
  
  try {
    const dirInfo = await FileSystem.getInfoAsync(epaperDir);
    
    if (!dirInfo.exists) {
      console.log('Directory not found:', 'No local epaper found.');
      return;
    }

    // Retrieve and log directory contents before deletion
    //const directoryContents = await FileSystem.readDirectoryAsync(epaperDir);
    //console.log('Files and folders found for deletion:', directoryContents);
    
    await FileSystem.deleteAsync(epaperDir, { idempotent: true });
    //console.log('Success:', 'Epaper folder deleted.');
  } catch (error) {
    console.error('Error deleting directory:', error);
    console.log('Error:', 'There was an error deleting the /epaper/ directory.');
  }
  */
};

export const deleteFile = async (filePath: string) => {

  try {

    await FileSystemPromises.access(filePath);
    await FileSystemPromises.rm(filePath);

    return true;
  } 
  catch (error) {
      console.error(`Error deleting file: ${error}`);
      return false;
  }

  /*
  try {
      const fileInfo = await FileSystem.getInfoAsync(filePath);
      if (fileInfo.exists) {
          await FileSystem.deleteAsync(filePath);
          //console.log(`File deleted successfully: ${filePath}`);
      } else {
          console.warn(`File not found: ${filePath}`);
      }
  } catch (error) {
      console.error(`Error deleting file: ${error}`);
  }
  */
};